module.exports = __webpack_public_path__ + "static/L5Y4s-ac22fa3d7d034e6500bfa6cb9fee2cac.jpg";